import { List } from 'immutable';
import { shareClassConstants } from '../constants';

export function share_classes(state = {}, action) {
  switch (action.type) {
    case shareClassConstants.SHARE_CLASS_LIST_LOADING:
      return {
        ...state,
        items: null,
        listLoading: true
      };
    case shareClassConstants.SHARE_CLASS_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case shareClassConstants.SHARE_CLASS_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: null,
        listError: action.error
      };
    case shareClassConstants.SHARE_CLASS_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case shareClassConstants.SHARE_CLASS_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case shareClassConstants.SHARE_CLASS_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case shareClassConstants.SHARE_CLASS_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case shareClassConstants.SHARE_CLASS_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const shareClassIndex = state.items.findIndex(val => val.id == action.response.id);

      if (shareClassIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(shareClassIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case shareClassConstants.SHARE_CLASS_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case shareClassConstants.SHARE_CLASS_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case shareClassConstants.SHARE_CLASS_DELETE_SUCCESS: {
      const { shareClassId } = action;

      if (!state.items) {
        return state;
      }

      const shareClassIndex = state.items.findIndex(val => val.id == shareClassId);

      if (shareClassIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(shareClassIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case shareClassConstants.SHARE_CLASS_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };
    case shareClassConstants.SHARE_CLASS_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    default:
      return state;
  }
}
